import { useEffect, useRef, useState } from "react"
import { useHistory } from "react-router-dom"
import { jwtDecode } from "jwt-decode";

import { getCountry, register, validateEmail } from '../../lib/api';
import { useModal } from "../../store/ModalContext";
import Button from '../UI/Button';
import Input from '../UI/Input';
import Dropdown from "../UI/Dropdown";
import useInput from '../../hooks/use-input';
import { isRegisterationCode, isFirstName, isLastName, isCompany, isPassword } from '../UI/Validations';

const isNotEmpty = (value) => value.trim() !== '';

const DisTributor = ({ setIsLoading, isLoading, jwt }) => {
    const history = useHistory();
    const { openContactUsModal } = useModal();
    const [isChecked, setIsChecked] = useState(false)
    const [unCheckedError, setUnCheckedError] = useState('');
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [unTermsError, setUnTermsError] = useState('');
    const [isEmailExist, setIsEmailExist] = useState(false);
    const [emailValue, setEmailHasValue] = useState();
    const [emailHasError, setEmailhasError] = useState();
    const [emailHasEmptyError, setEmailHasEmptyError] = useState(false);
    const [companyHasError, setCompanyHasError] = useState();
    const [companyHasEmptyError, setCompanyHasEmptyError] = useState(false);
    const [selectedCountryOption, setSelectedCountryOption] = useState(null);
    const [isCountryValid, setCountryValid] = useState(false);
    const [countryOptionsList, setCountryOptionsList] = useState([]);
    const [countryHasError, setCountryHasError] = useState();
    const [preFilled, setPreFilled] = useState("");
    const [formDisplay, setFormDisplay] = useState(false);

    const isValidJwt = (token) => token && token.split(".").length === 3;

    const isTokenExpired = (token) => {
        const currentTime = Date.now() / 1000;
        return false;
    };

    useEffect(() => {
        if (isValidJwt(jwt)) {
            const token = jwtDecode(jwt);
            validateEmail(token.eid)
                .then((response) => {
                    if (response.length > 0) {
                        history.push('/');
                    }
                })
                .catch((error) => {
                    console.log(error)
                });
            if (isTokenExpired(token)) {
                setPreFilled("");
            } else {
                setFormDisplay(true);
                setPreFilled(token);
            }
        } else {
            if (jwt !== undefined) {
                history.push('/');
            }
            setPreFilled("");
        }
    }, [jwt]);

    // const handleCountryOption = (option) => {
    //     setSelectedCountryOption(option);
    //     setCountryValid(true);
    //     setCountryHasError()
    // };

    // const handleBlur = (isValid) => {
    //     setCountryValid(isValid);
    //     setCountryHasError("Please select your country.")
    // };

    const handleEmailValidate = () => {
        validateEmail(emailInputRef?.current?.value)
            .then((response) => {
                if (response.length > 0) {
                    return setIsEmailExist(true)
                }
                else return setIsEmailExist(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const companyValidation = (value) => {
        if (!value) { setCompanyHasEmptyError(false); setCompanyHasError("Please enter company name") }
        else if (value[0] === ' ') { setCompanyHasEmptyError(false); setCompanyHasError("Email cannot start with space") }
        //   else if (!value.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) { setCompanyHasEmptyError(false); setCompanyHasError("Please enter valid email") }
        else { setCompanyHasEmptyError(true); setCompanyHasError('') }
    }

    const emailValidation = (value) => {
        if (!value) { setEmailHasEmptyError(false); setEmailhasError("Please enter email") }
        else if (value[0] === ' ') { setEmailHasEmptyError(false); setEmailhasError("Email cannot start with space") }
        else if (!value.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) { setEmailHasEmptyError(false); setEmailhasError("Please enter valid email") }
        else { handleEmailValidate(); setEmailHasEmptyError(true); setEmailhasError('') }
        setEmailHasValue(value.replace(/\s/g, ''))
    }

    const handleCompanyEventChange = (e) => {
        e.preventDefault();
        console.log(e.target)
        let { id, value } = e.target;
        if (id === "companyName") {
            companyValidation(value)
        }
    }

    const handleEmailChange = (e) => {
        e.preventDefault();
        setIsEmailExist(false)
        let { id, value } = e.target;
        if (id === "email") {
            emailValidation(value)
        }
    }

    const handleEmailBlur = (e) => {
        e.preventDefault();
        let { id, value } = e.target;
        if (id === "email") {
            emailValidation(value)
        }
    }

    const titleInputRef = useRef();
    const firstNameInputRef = useRef();
    const registrationCodeInputRef = useRef();
    const lastNameInputRef = useRef();
    const companyNameInputRef = useRef();
    const countryNameInputRef = useRef();
    const emailInputRef = useRef();
    const createPasswordInputRef = useRef();
    const confirmPasswordInputRef = useRef();

    const {
        value: titleValue,
        valueChangeHandler: titleChangeHandler,
        inputBlurHandler: titleBlurHandler,
    } = useInput(isNotEmpty);

    // const {
    //     value: registrationCodeValue,
    //     isValid: registrationCodeIsValid,
    //     hasError: registrationCodeHasError,
    //     valueChangeHandler: registrationCodeChangeHandler,
    //     inputBlurHandler: registrationCodeBlurHandler,
    // } = useInput(isRegisterationCode);

    const {
        value: firstNameValue,
        isValid: firstNameIsValid,
        hasError: firstNameHasError,
        valueChangeHandler: firstNameChangeHandler,
        inputBlurHandler: firstNameBlurHandler,
    } = useInput(isFirstName);

    const {
        value: lastNameValue,
        isValid: lastNameIsValid,
        hasError: lastNameHasError,
        valueChangeHandler: lastNameChangeHandler,
        inputBlurHandler: lastNameBlurHandler,
    } = useInput(isLastName);

    const {
        value: companyNameValue,
        isValid: companyNameIsValid,
        hasError: companyNameHasError,
        valueChangeHandler: companyNameChangeHandler,
        inputBlurHandler: companyNameBlurHandler,
    } = useInput(isCompany);

    const {
        value: createPasswordValue,
        isValid: createPasswordIsValid,
        hasError: createPasswordHasError,
        valueChangeHandler: createPasswordChangeHandler,
        inputBlurHandler: createPasswordBlurHandler,
    } = useInput(isPassword);

    const {
        value: confirmPasswordValue,
        isValid: confirmPasswordIsValid,
        hasError: confirmPasswordHasError,
        valueChangeHandler: confirmPasswordChangeHandler,
        inputBlurHandler: confirmPasswordBlurHandler,
    } = useInput(isPassword, createPasswordValue);

    let formIsValid = false;

    if (((jwt !== undefined) &&
        isChecked &&
        !createPasswordIsValid &&
        !createPasswordIsValid &&
        !confirmPasswordIsValid &&
        isTermsChecked
    ) || (isChecked &&
        !createPasswordIsValid &&
        !createPasswordIsValid &&
        !confirmPasswordIsValid &&
        isTermsChecked
        )) {
        formIsValid = true
    }

    const handleCheckbox = (event) => {
        setIsChecked(event.target.checked)
        if (!event.target.checked) {
            setUnCheckedError('Please check the checkbox to proceed further');
        } else setUnCheckedError('')
    }

    const handleTermsCheckbox = (event) => {
        setIsTermsChecked(event.target.checked)
        if (!event.target.checked) {
            setUnTermsError('Please check the checkbox to proceed further');
        } else setUnTermsError('')
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!formIsValid) {
            return;
        }

        setIsLoading(true);

        // const enteredRegistrationCode = registrationCodeInputRef.current.value;
        const enteredTitle = titleInputRef.current.value;
        const enteredFirstname = firstNameInputRef.current.value;
        const enteredLastname = lastNameInputRef.current.value;
        const enteredCompanyName = companyNameInputRef.current.value;
        const enteredCountryName = countryNameInputRef.current.value;
        const enteredEmail = emailInputRef.current.value;
        const enteredPassword = createPasswordInputRef.current.value;

        const formData = {
            // field_registeration_code: {
            //     value: enteredRegistrationCode
            // },
            name: {
                value: enteredEmail,
            },
            pass: {
                value: enteredPassword,
            },
            field_name_title: {
                value: enteredTitle,
            },
            field_first_name: {
                value: enteredFirstname,
            },
            field_last_name: {
                value: enteredLastname,
            },
            field_company_name: {
                value: enteredCompanyName,
            },
            field_country: {
                value: enteredCountryName,
            },
            mail: {
                value: enteredEmail,
            },
            field_user_type: {
                value: "2"
            }
        };
        register(formData)
            .then(async (res) => {
                setIsLoading(false);
                if (res.uid.length > 0) {
                    history.push('/distributorConfirmation')
                }
            })
            .catch((error) => {
                setIsLoading(false);
            })
    }

    useEffect(() => {
        countrysendRequest()
    }, [])

    const countrysendRequest = () => {
        getCountry()
            .then((response) => {
                const options = response?.data.map((details) => ({
                    id: details.id,
                    value: details.country_name,
                }));
                setCountryOptionsList(options);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleTermsandService = () => {
        window.open("/linkdetail/terms-service", "_blank");
    }

    const handlePrivacyPolicy = () => {
        window.open("/linkdetail/privacy-statement", "_blank");
    }

    const handleOrganizationMessage = () => {
        window.open("/linkdetail/messages-organization", "_blank");
    }

    const handleCookiesPolicy = () => {
        window.open("/linkdetail/cookie-policy", "_blank");
    }

    const contactusHandle = () => {
        openContactUsModal();
    }

    return (
        <>
            <div className="tabContentHolder">
                <div className="tabContentTwo">
                    {/* <p className="text-[#333] text-sm leading-5 md:text-base  font-normal max-w-[75%] sm:max-w-[50%]  block md:hidden mt-4">If you are a HOYA Surgical Distributor please click hear to register.</p> */}
                    <div className="mt-4 sm:mt-11">
                        {!formDisplay && (
                            <div className="flex items-center gap-[90px]">
                                <p className="text-[#333] leading-normal font-normal text-base">If you are a HOYA Surgical Optics Distributor and would like to register, please contact your HOYA Surgical Optics representative or use the <span className="text-primaryBlue leading-5 font-normal text-sm cursor-pointer" onClick={contactusHandle}>Contact Form.</span></p>
                            </div>
                        )}
                        {formDisplay && (
                            <div className="flex items-center gap-[90px]">
                                <div className="formHolder basis-full lg:basis-[70%] shrink-0">
                                    <form onSubmit={handleSubmit} className="registerForm customer space-y-6 *:flex-wrap sm:*:flex-nowrap">
                                        {/* <div className="flex items-center gap-x-12 gap-y-6 *:grow *:shrink names *:basis-full sm:basis-1/2">
                                        <div className="registrationSection gap-[6px] flex flex-col">
                                            <Input
                                                ref={registrationCodeInputRef}
                                                label="Registration Code"
                                                labelClass="registrationCodeLabel text-[#333] text-sm font-normal leading-5"
                                                isManditory={false}
                                                input={{
                                                    id: "registrationCode",
                                                    name: "registrationCode",
                                                    type: "text",
                                                    // value: registrationCodeValue,
                                                    placeholder: "Enter Registeration Code",
                                                    // onChange: (registrationCodeChangeHandler),
                                                    // onBlur: registrationCodeBlurHandler,
                                                    className:
                                                        "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  text-sm",
                                                }}
                                            />
                                            {registrationCodeHasError && (
                                                <p className="error-text">
                                                    {registrationCodeIsValid}
                                                </p>
                                            )}

                                        </div>
                                        <div className="nameSection gap-[6px]  flex-col sm:invisible hidden sm:block">
                                            <label className="titleLabel text-[#333] text-sm font-normal leading-5">dummy</label>
                                            <input type="text" className="p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 placeholder:text-[#666] text-sm " placeholder="dummy" />
                                        </div>
                                    </div> */}
                                        <div className="flex items-center gap-x-12 gap-y-6 *:grow *:shrink names *:basis-full sm:basis-1/2">
                                            <div className="flex flex-col sm:flex-row gap-6 sm:gap-5">
                                                <div className="titleSection gap-1 flex flex-col basis-full sm:basis-[120px] lg:basis-1/4 lg:grow xl:grow-0">
                                                    <Input
                                                        ref={titleInputRef}
                                                        label="Title"
                                                        labelClass="firstNameLabel text-[#333] text-sm font-normal leading-5"
                                                        input={{
                                                            id: "title",
                                                            name: "title",
                                                            type: "text",
                                                            value: titleValue,
                                                            placeholder: "Mr/Ms/Mrs",
                                                            onChange: titleChangeHandler,
                                                            onBlur: titleBlurHandler,
                                                            className:
                                                                "p-[10px] w-full rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666] !text-[#333]",
                                                        }}
                                                    />
                                                </div>
                                                <div className="nameSection gap-[6px] flex flex-col grow">
                                                    <Input
                                                        ref={firstNameInputRef}
                                                        label="First Name"
                                                        labelClass="firstNameLabel text-[#333] text-sm font-normal leading-5"
                                                        isManditory={true}
                                                        input={{
                                                            id: "firstName",
                                                            name: "firstName",
                                                            type: "text",
                                                            value: preFilled?.firstname,
                                                            placeholder: "Enter First Name",
                                                            onChange: firstNameChangeHandler,
                                                            onBlur: firstNameBlurHandler,
                                                            className:
                                                                `${preFilled?.firstname ? "disabled" : ""} p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  text-sm`,
                                                        }}
                                                    />
                                                    {firstNameHasError && (
                                                        <p className="error-text">
                                                            {firstNameIsValid}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="nameSection gap-[6px] flex flex-col grow">
                                                <Input
                                                    ref={lastNameInputRef}
                                                    label="Last Name"
                                                    labelClass="lastNameLabel text-[#333] text-sm font-normal leading-5"
                                                    isManditory={true}
                                                    input={{
                                                        id: "lastName",
                                                        name: "lastName",
                                                        type: "text",
                                                        value: preFilled?.lastname,
                                                        placeholder: "Enter Last Name",
                                                        onChange: lastNameChangeHandler,
                                                        onBlur: lastNameBlurHandler,
                                                        className:
                                                            `${preFilled?.lastname ? "disabled" : ""} p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  text-sm`,
                                                    }}
                                                />
                                                {lastNameHasError && (
                                                    <p className="error-text">
                                                        {lastNameIsValid}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-x-12 gap-y-6 *:grow *:shrink names *:basis-full sm:basis-1/2">
                                            <div className="companyInfo gap-[6px] flex flex-col">
                                                <Input
                                                    ref={companyNameInputRef}
                                                    label="Distributor Name"
                                                    labelClass="companyNameLabel text-[#333] text-sm font-normal leading-5"
                                                    isManditory={true}
                                                    input={{
                                                        id: "companyName",
                                                        name: "companyName",
                                                        type: "text",
                                                        value: preFilled?.dname,
                                                        placeholder: "Enter Distributor Name",
                                                        onChange: (e) => handleCompanyEventChange(e),
                                                        onBlur: (e) => handleCompanyEventChange(e),
                                                        // onChange: companyNameChangeHandler,
                                                        // onBlur: preFilled?.dname ? () => { return false; } : companyNameBlurHandler,
                                                        className:
                                                            `${preFilled?.dname ? "disabled" : ""} p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  text-sm`,
                                                    }}
                                                />

                                                {!companyHasEmptyError && (
                                                    <p className="error-text">
                                                        {companyHasError}
                                                    </p>
                                                )}

                                            </div>
                                            <div className="countrySection gap-[6px] flex flex-col relative">
                                                {/* <Dropdown
                                                    label="Country"
                                                    labelClass="countryLabel text-[#333] text-sm font-normal leading-5"
                                                    placeholder="Select a Country"
                                                    isManditory={true}
                                                    options={countryOptionsList}
                                                    onSelect={handleCountryOption}
                                                    onBlur={(isValid) => handleBlur(isValid)}
                                                    isValid={isCountryValid} // Pass validation state for dropdown 1
                                                    selectedValue={selectedCountryOption}
                                                /> */}
                                                <Input
                                                    ref={countryNameInputRef}
                                                    label="Country"
                                                    labelClass="lastNameLabel text-[#333] text-sm font-normal leading-5"
                                                    isManditory={true}
                                                    input={{
                                                        id: "country",
                                                        name: "country",
                                                        type: "text",
                                                        value: preFilled?.country,
                                                        placeholder: "Country",
                                                        className:
                                                            `${preFilled?.country ? "disabled" : ""} p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  text-sm`,
                                                    }}
                                                />

                                                {(!isCountryValid && countryHasError) && (
                                                    <p className="error-text">
                                                        {countryHasError}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-x-12 gap-y-6 *:grow *:shrink emailSections *:basis-full sm:basis-1/2">
                                            <div className="emailSection gap-[6px] flex flex-col">
                                                <Input
                                                    ref={emailInputRef}
                                                    label="Email"
                                                    labelClass="emailNameLabel text-[#333] text-sm font-normal leading-5"
                                                    isManditory={true}
                                                    input={{
                                                        id: "email",
                                                        name: "email",
                                                        type: "text",
                                                        value: preFilled?.eid,
                                                        placeholder: "Enter Your Email",
                                                        onChange: (e) => handleEmailChange(e),
                                                        onBlur: (e) => handleEmailBlur(e),
                                                        className:
                                                            `${preFilled?.eid ? "disabled" : ""} p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]`,
                                                    }}
                                                />
                                                {!emailHasEmptyError && (
                                                    <p className="error-text">
                                                        {emailHasError}
                                                    </p>
                                                )}
                                                {(isEmailExist) && (
                                                    <p className='error-text'>
                                                        This Email is already taken. Please try with another email.
                                                    </p>
                                                )}
                                            </div>
                                            <div className="nameSection gap-[6px]  flex-col sm:invisible hidden sm:block">
                                                <label className="titleLabel text-[#333] text-sm font-normal leading-5">dummy</label>
                                                <input type="text" className="p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 placeholder:text-[#666] text-sm " placeholder="dummy" />
                                            </div>
                                        </div>
                                        <div className="flex items-center gap-x-12 gap-y-6 *:grow *:shrink professonSpeciality *:basis-full sm:basis-1/2">
                                            <div className="createPasswordSection gap-[6px] flex flex-col">
                                                <Input
                                                    ref={createPasswordInputRef}
                                                    label="Password"
                                                    labelClass="passwordLabel text-[#333] text-sm font-normal leading-5"
                                                    isManditory={true}
                                                    input={{
                                                        id: "password",
                                                        name: "password",
                                                        type: "password",
                                                        value: createPasswordValue,
                                                        placeholder: "Create Password",
                                                        onChange: createPasswordChangeHandler,
                                                        onBlur: createPasswordBlurHandler,
                                                        className:
                                                            "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]",
                                                    }}
                                                />
                                                {createPasswordHasError && (
                                                    <p className="error-text">
                                                        {createPasswordIsValid}
                                                    </p>
                                                )}
                                            </div>
                                            <div className="createPasswordSection gap-[6px] flex flex-col">
                                                <Input
                                                    ref={confirmPasswordInputRef}
                                                    label="Confirm Password"
                                                    labelClass="confirmPasswordLabel text-[#333] text-sm font-normal leading-5"
                                                    isManditory={true}
                                                    input={{
                                                        id: "confirmPassword",
                                                        name: "confirmPassword",
                                                        type: "password",
                                                        value: confirmPasswordValue,
                                                        placeholder: "Enter Confirm Password",
                                                        onChange: confirmPasswordChangeHandler,
                                                        onBlur: confirmPasswordBlurHandler,
                                                        className:
                                                            "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]",
                                                    }}
                                                />
                                                {confirmPasswordHasError && (
                                                    <p className="error-text">Passwords do NOT match!</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="accountCreationAccpect">
                                            <div className="flex gap-3 items-start">
                                                <input
                                                    type="checkbox"
                                                    onChange={(event) => handleCheckbox(event)}
                                                    className="size-5 rounded-lg shrink-0 border-2 border-loginFieldBorder mt-1"
                                                />
                                                <p className="text-[#333] leading-normal font-normal text-base">I permit The Source to send me updates from its personalized alerts and <span className="text-primaryBlue leading-5 font-normal text-sm cursor-pointer" onClick={handleOrganizationMessage}>Messages from organization.</span></p>
                                            </div>
                                            {!isChecked && unCheckedError && (<p className="error-text mt-1">{unCheckedError}</p>)}

                                            <div className="flex gap-3 items-start mt-2">
                                                <input
                                                    type="checkbox"
                                                    className="size-5 rounded-lg shrink-0 border-2 border-loginFieldBorder mt-1"
                                                    onChange={(event) => handleTermsCheckbox(event)} />
                                                <div className='flex flex-col items-start'>
                                                    <p className="text-[#333] leading-normal font-normal text-sm sm:text-base">
                                                        I agree to the <span className="text-primaryBlue leading-5 font-normal text-sm cursor-pointer" onClick={handleTermsandService} >Terms of Service</span>
                                                    </p>
                                                    <p className="text-[#333] leading-normal font-normal text-sm sm:text-base">
                                                        Learn how we collect, use and share your data in our <span className="text-primaryBlue leading-5 font-normal text-sm cursor-pointer" onClick={handlePrivacyPolicy} >Privacy Statement</span> and how we use cookies in our <span className="text-primaryBlue leading-5 font-normal text-sm cursor-pointer" onClick={handleCookiesPolicy} >Cookie Policy.</span>
                                                    </p>
                                                </div>
                                            </div>
                                            {!isTermsChecked && unTermsError && <p className="error-text mt-1">{unTermsError}</p>}

                                            {!isLoading && (
                                                <Button
                                                    disabled={!formIsValid}
                                                    type='submit'
                                                    className={!formIsValid ? "btn disabled mt-8 continueBtn w-auto bg-primaryBlue h-[46px] px-20 py-[10px] font-bold leading-5 text-base justify-center  rounded text-white inline-flex items-center" : "btn mt-8 continueBtn w-auto bg-primaryBlue h-[46px] px-20 py-[10px] font-bold leading-5 text-base justify-center  rounded text-white inline-flex items-center"}
                                                >
                                                    Continue
                                                </Button>
                                            )}
                                        </div>
                                    </form>
                                </div>
                                <div className="videoSection !hidden lg:flex lg:basis-[420px] shrink grow">
                                    <div className="videoHolder aspect-video w-full">
                                        <video src="../src/videos/video.mp4" className="h-full" controls muted></video>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default DisTributor;
